import { render, staticRenderFns } from "./ModalMain.vue?vue&type=template&id=b83ae79c&scoped=true"
import script from "./ModalMain.vue?vue&type=script&lang=js"
export * from "./ModalMain.vue?vue&type=script&lang=js"
import style0 from "./Modal.scss?vue&type=style&index=0&id=b83ae79c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83ae79c",
  null
  
)

export default component.exports